export interface RawApiReportingJobResponse {
  id: string;
  campaign_id: string;
  advertiser_id: string;
  status: ReportingJobStatus;
  start_date: string;
  end_date: string;
  configuration: ReportingJobConfig;
  created_at: string;
  updated_at: string;
}

export enum ReportingJobStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  FAILED = 'FAILED',
}

export interface ReportingJobConfig {
  attribution: AttributionConfig;
}

export interface AttributionConfig {
  mode: AttributionConfigMode;
  lookback_window_days: number;
  product_match: AttributionConfigProductMatch;
  assisted_ads: boolean | null;
}

export enum AttributionConfigMode {
  POST_CLICK = 'POST_CLICK',
  POST_VIEW = 'POST_VIEW',
  LAST_TOUCH = 'LAST_TOUCH',
}

export enum AttributionConfigProductMatch {
  SKU = 'SKU',
  CATEGORY = 'CATEGORY',
  BRAND = 'BRAND',
}

export interface CreateCampaignReportingJobRequest {
  campaign_id: string;
  configuration: ReportingJobConfig;
  start_date?: string | null;
  end_date?: string | null;
}
